
import Button from '../../../components/base/Button';

export default function NewsSection() {
  const newsItems = [
    {
      title: "2025-2026 Indigenous Pharmacy Scholarship Recipients Announced",
      summary: "CPVA announces scholarship recipients supporting Indigenous pharmacy professionals across Canada.",
      date: "January 15, 2025",
      category: "Scholarships",
      image: "https://public.readdy.ai/ai/img_res/d85d05020f3cecee63b5ee6667f5c147.jpg"
    },
    {
      title: "New CE/CPD Modules Available: Advanced Pain Management",
      summary: "Comprehensive continuing education modules now available for pharmacists and veterinarians focusing on pain management protocols.",
      date: "January 12, 2025", 
      category: "Education",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20professionals%20in%20educational%20seminar%20about%20pain%20management%2C%20medical%20training%20session%2C%20continuing%20education%20classroom%2C%20professional%20development%20workshop%2C%20healthcare%20learning%20environment&width=400&height=250&seq=news2&orientation=landscape"
    },
    {
      title: "Policy Update: Expanded Scope for Veterinary Pharmacists",
      summary: "New regulations expand collaborative practice opportunities between veterinarians and pharmacists in medication management.",
      date: "January 10, 2025",
      category: "Policy",
      image: "https://readdy.ai/api/search-image?query=Policy%20makers%20and%20healthcare%20professionals%20in%20government%20meeting%2C%20legislative%20discussion%20about%20healthcare%20regulations%2C%20professional%20policy%20development%2C%20government%20building%20meeting%20room&width=400&height=250&seq=news3&orientation=landscape"
    },
    {
      title: "Community Spotlight: Rural Health Initiative Success",
      summary: "Local pharmacy-veterinary partnerships improve health outcomes in rural Canadian communities.",
      date: "January 8, 2025",
      category: "Community",
      image: "https://readdy.ai/api/search-image?query=Rural%20healthcare%20clinic%20with%20pharmacists%20and%20veterinarians%20serving%20community%2C%20small%20town%20medical%20facility%2C%20countryside%20healthcare%20setting%2C%20community%20health%20services%2C%20rural%20medical%20practice&width=400&height=250&seq=news4&orientation=landscape"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            News & Updates
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stay informed with the latest policy updates, educational opportunities, and success stories from across Canada's healthcare community.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {newsItems.map((item, index) => (
            <article key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium">
                    {item.category}
                  </span>
                  <time className="text-sm text-gray-500">
                    {item.date}
                  </time>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {item.summary}
                </p>
                <Button variant="outline" size="sm">
                  Read More
                </Button>
              </div>
            </article>
          ))}
        </div>
        
        <div className="text-center">
          <Button size="lg" className="bg-red-600 hover:bg-red-700">
            Read More News
          </Button>
        </div>
      </div>
    </section>
  );
}
